import { type CalendarItem } from './types'

/**
 * How much of the calendar is left after the filters, by kind.
 *
 * The two kinds are counted apart because they are two different things to
 * look for: "19 moments" and "200 content" answer different questions, and one
 * number over both answers neither.
 */
export type CalendarResultCounts = Readonly<{
  content: number
  moments: number
}>

/**
 * The items on the calendar, counted by kind.
 *
 * One item is one count. A moment that runs across a fortnight is drawn as a
 * bar on every week it crosses, and it is still one moment.
 */
export const countByKind = (
  items: readonly CalendarItem[]
): CalendarResultCounts => ({
  content: items.filter((item) => item.kind === 'content').length,
  moments: items.filter((item) => item.kind === 'moment').length,
})
